import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import React from 'react';
import PropTypes from 'prop-types';
import Card from 'orion/lib/card';
import FormGroup from 'orion/lib/formGroup';
import Label from 'orion/lib/label';
import Input from 'orion/lib/input';
import InputFeedback from 'orion/lib/inputFeedback';
import Select from 'orion/lib/select';
import Col from 'orion/lib/col';
import { useDruvaAlerts } from '../../contexts/DruvaAlertsContext';

var AlertSubscriptionForm = function AlertSubscriptionForm(props) {
  var adminList = props.adminList,
      fetchingAdmins = props.fetchingAdmins,
      touched = props.touched,
      errors = props.errors;

  var _useDruvaAlerts = useDruvaAlerts(),
      labelForAdminRole = _useDruvaAlerts.uiConfig.labelForAdminRole;

  return /*#__PURE__*/React.createElement(Card, {
    className: "oui-mt-3",
    title: "Email Notification",
    body: function body() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormGroup, {
        row: true,
        className: "oui-h-110 form-group-mn100"
      }, /*#__PURE__*/React.createElement(Label, {
        text: "Subscribers",
        sm: 3
      }), /*#__PURE__*/React.createElement(Col, {
        sm: 6
      }, /*#__PURE__*/React.createElement(Input, {
        type: "radio",
        id: "all-admin",
        value: "2",
        name: "subscriptionType",
        label: labelForAdminRole,
        validationProps: props,
        isInvalid: touched.subscriptionType && errors.subscriptionType !== undefined
      }), /*#__PURE__*/React.createElement(Input, {
        type: "radio",
        id: "selected-admin",
        value: "1",
        name: "subscriptionType",
        label: "Specific Administrators",
        className: "oui-mt-2",
        validationProps: props,
        isInvalid: touched.subscriptionType && errors.subscriptionType !== undefined
      }), /*#__PURE__*/React.createElement(Select, {
        type: "select",
        className: "oui-mt-2",
        name: "subscribers",
        isMulti: true,
        placeholder: "Select subscribers",
        options: adminList,
        validationProps: props,
        defaultValue: props.initialValues.subscribers,
        isDisabled: fetchingAdmins || _parseInt(_valuesInstanceProperty(props).subscriptionType, 10) !== 1,
        isInvalid: touched.subscribers && errors.subscribers !== undefined
      }), /*#__PURE__*/React.createElement(InputFeedback, {
        show: touched.subscriptionType && errors.subscriptionType !== undefined,
        message: errors.subscriptionType
      }))), /*#__PURE__*/React.createElement(FormGroup, {
        row: true,
        className: "form-group-h160"
      }, /*#__PURE__*/React.createElement(Label, {
        text: "Email Frequency",
        sm: 3
      }), /*#__PURE__*/React.createElement(Col, {
        sm: 9
      }, /*#__PURE__*/React.createElement(Input, {
        type: "radio",
        name: "notificationFrequency",
        className: "oui-mt-2",
        label: "Instantaneous",
        value: "1",
        validationProps: props,
        isInvalid: props.touched.notificationFrequency && props.errors.notificationFrequency !== undefined
      }), /*#__PURE__*/React.createElement("p", {
        className: "oui-text-muted oui-pl-4 p-subtext"
      }, "Receive email notifications for every alert as soon as they are generated."), /*#__PURE__*/React.createElement(Input, {
        type: "radio",
        name: "notificationFrequency",
        className: "oui-mt-2",
        label: "Daily digest",
        value: "2",
        validationProps: props,
        isInvalid: touched.notificationFrequency && errors.notificationFrequency !== undefined
      }), /*#__PURE__*/React.createElement("p", {
        className: "oui-text-muted oui-pl-4 p-subtext"
      }, "Receive single collated email daily containing the activity for this alert every day at 10:00 am."), /*#__PURE__*/React.createElement(Input, {
        type: "radio",
        name: "notificationFrequency",
        className: "oui-mt-2",
        label: "Weekly digest",
        value: "3",
        validationProps: props,
        isInvalid: touched.notificationFrequency && errors.notificationFrequency !== undefined
      }), /*#__PURE__*/React.createElement("p", {
        className: "oui-text-muted oui-pl-4 p-subtext"
      }, "Receive single collated email weekly containing the activity for this alert every Monday at 10:00 am."), /*#__PURE__*/React.createElement(InputFeedback, {
        show: touched.notificationFrequency && errors.notificationFrequency !== undefined,
        message: errors.notificationFrequency
      }))));
    }
  });
};

AlertSubscriptionForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  adminList: PropTypes.array.isRequired,
  fetchingAdmins: PropTypes.bool.isRequired
};
export default AlertSubscriptionForm;